module.exports = __webpack_public_path__ + "static/media/calendarTime.bd3f0b0d.svg";